module.exports = __webpack_public_path__ + "img/logo2.03634d03.png";